import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Button, Popup } from 'semantic-ui-react'

/**
 * PopupButton.
 * @extends Component
 */
class PopupButton extends Component {
  static propTypes = {
    icon: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    popupContent: PropTypes.string.isRequired,
    text: PropTypes.string,
  }

  static defaultProps = {
    icon: '',
    text: '',
  }

  render() {
    const { icon, onClick, popupContent, text } = this.props

    return (
      <Popup
        content={popupContent}
        size="mini"
        trigger={<Button content={text ? text : null} icon={icon ? icon : null} onClick={onClick} />}
      />
    )
  }
}

export default PopupButton
